import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { add, divide, multiply, subtract } from 'mathjs';
import { useAuthUser } from 'react-auth-kit';
// import { Bar, Line } from 'react-chartjs-2';
import { useReactToPrint } from 'react-to-print';
import {  Printer } from '../printing/printing_component.js';
// import { Chart as ChartJS, LineElement, PointElement, LinearScale, Title } from 'chart.js';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// GRAPHQL QUERY
// import { 
//     GetUsersQRCodes,
//     SaveUserQRCode
// } from './users_graphql.js';

// DOCS: https://www.apollographql.com/docs/react/get-started/
// Import everything needed to use the `useQuery` hook

export function WorkoutsGraphComponent(props) {

    const targetRef = useRef(null);
    
    let Workouts = [...props.Workouts];

    // Sort workouts by exercise date to create Labels
    let SortedWorkouts = Workouts.sort(function(a,b) {
                                                if(a.exercise_date < b.exercise_date) return -1;
                                                if(a.exercise_date > b.exercise_date) return 1;
                                                return 0;
                                            })

    const XAxisLabels = SortedWorkouts.map((W) => dayjs(W.exercise_date).format('M-D-YY'));

    const [Arm, setArm] = useState(['R']);
    const [Exercises, setExercises] = useState(['supra','infra','teres','subscap','house']);
    const [GraphData, setGraphData] = useState({
        labels: XAxisLabels,
        datasets: []
    });
    const [GraphGenerated, setGraphGenerated] = useState(false);
    const [GraphOptions, setGraphOptions] = useState({
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: '',
            },
            datalabels: {
                backgroundColor: function(context) {
                    console.log({context})
                    return context.dataset.backgroundColor;
                },
                borderRadius: 4,
                color: 'white',
                font: {
                    weight: 'bold'
                },
                formatter: function(value) {
                    return null;
                    console.log("FORMTER GOES EHRE 12: ", value)
                    if (value == '0.000' ) return null;
                    else return value.y
                },
                padding: 6
            }
        },
        scales: {
            y: {
                beginAtZero: true, // Start the Y-axis at zero
                max: 20, // Set the maximum value of the Y-axis
                min: 0, // Set the minimum value of the Y-axis
                ticks: {
                    stepSize: 2, // Set the step size of the Y-axis ticks
                },
            },
        }
    });
    const [GraphType, setGraphType] = useState('bar');
    const [EndDate, setEndDate] = useState('');
    const [StartDate, setStartDate] = useState('');
    

    console.log("Workouts Graph props: ", props)
    useEffect(() => {
        // The code we want to run (on load)
        handleGenerateGraph();

        // Optional return function
        // return () => { };

    }, [Arm,Exercises,EndDate,StartDate]);

    if ( Workouts.length == 0 ) {
        return;
    }

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend,
        ChartDataLabels
    );

    // {
    //     label: 'My First dataset',
    //     backgroundColor: 'rgba(255,99,132,0.2)',
    //     borderColor: 'rgba(255,99,132,1)',
    //     borderWidth: 1,
    //     stack: 1,
    //     hoverBackgroundColor: 'rgba(255,99,132,0.4)',
    //     hoverBorderColor: 'rgba(255,99,132,1)',
    //     data: [65, 59, 80, 81, 56, 55, 40]
    // },

    function Printing(printing_props) {
        const componentRef = useRef();
        const handlePrint = useReactToPrint({
            content: () => componentRef.current
        });
        //marginTop: 150+'px', marginLeft: 50+'px', 
        console.log("window.innerWidth: ", window.innerWidth)
        return (
           <>
                <div className="card-body"
                    style={{ 
                        width: subtract(window.innerWidth,100)+'px',
                        height: subtract(window.innerHeight,120)+'px',
                        display: 'flex', justifyContent: 'center'
                    }}
                >
                    <Printer graph_type={GraphType} ref={componentRef} options={GraphOptions} data={GraphData} />
                </div>
                <div className="text-center mb-1">
                    <button className={printing_props.class} onClick={handlePrint}><FontAwesomeIcon icon="fa-print" size="xl" className="me-2" />{printing_props.button}</button>
                </div>
            </>
        );
    };

    // Handle generating graph data and options for exercise and arm
    function handleGenerateGraph() {

        // We will have 10 potential datasets - L / R each for 5 exercises
        // let DSupra = SortedBenchmarks.map((SB) => SB[`${Arm}1_weight_${Exercise}`]);
        let RSupra = [{y:null}];
        let LSupra = [{y:null}];
        let RSubscap = [{y:null}];
        let LSubscap = [{y:null}];
        let RInfra = [{y:null}];
        let LInfra = [{y:null}];
        let RTeres = [{y:null}];
        let LTeres = [{y:null}];
        let RHouse = [{y:null}];
        let LHouse = [{y:null}];

        // Give a workout, create the Sets data for display in the tooltip
        function createSetData(W, exercise, arm) {
            let Sets = [];
            let i;
            for(i=1; i < 6; i++) {
                if ( W[`${arm}${i}_rep_${exercise}`] > 0 && W[`${arm}${i}_weight_${exercise}`] > 0 ) {
                    Sets.push({reps: W[`${arm}${i}_rep_${exercise}`], weight: W[`${arm}${i}_weight_${exercise}`]});
                }
            }
            return Sets
        }
    
        if ( Arm.findIndex((A) => A === 'R') > -1 ) {
            if ( Exercises.findIndex((E) => E === 'supra') > -1 ) RSupra = SortedWorkouts.map((SB) => { return { y: SB.R_torque_supra, Sets: createSetData(SB, 'supra', 'R'), exercise_date: SB.exercise_date } });
            if ( Exercises.findIndex((E) => E === 'subscap') > -1 ) RSubscap = SortedWorkouts.map((SB) => { return { y: SB.R_torque_subscap, Sets: createSetData(SB, 'subscap', 'R'), exercise_date: SB.exercise_date } });
            if ( Exercises.findIndex((E) => E === 'infra') > -1 ) RInfra = SortedWorkouts.map((SB) => { return { y: SB.R_torque_infra, Sets: createSetData(SB, 'infra', 'R'), exercise_date: SB.exercise_date } });
            if ( Exercises.findIndex((E) => E === 'teres') > -1 ) RTeres = SortedWorkouts.map((SB) => { return { y: SB.R_torque_teres, Sets: createSetData(SB, 'teres', 'R'), exercise_date: SB.exercise_date } });
            if ( Exercises.findIndex((E) => E === 'house') > -1 ) RHouse = SortedWorkouts.map((SB) => { return { y: SB.R_torque_surfer, Sets: createSetData(SB, 'surfer', 'R'), exercise_date: SB.exercise_date } });
        }
        if ( Arm.findIndex((A) => A === 'L') > -1 ) {
            if ( Exercises.findIndex((E) => E === 'supra') > -1 ) LSupra = SortedWorkouts.map((SB) => { return { y: SB.L_torque_supra, Sets: createSetData(SB, 'supra', 'L'), exercise_date: SB.exercise_date } });
            if ( Exercises.findIndex((E) => E === 'subscap') > -1 ) LSubscap = SortedWorkouts.map((SB) => { return { y: SB.L_torque_subscap, Sets: createSetData(SB, 'subscap', 'L'), exercise_date: SB.exercise_date } });
            if ( Exercises.findIndex((E) => E === 'infra') > -1 ) LInfra = SortedWorkouts.map((SB) => { return { y: SB.L_torque_infra, Sets: createSetData(SB, 'infra', 'L'), exercise_date: SB.exercise_date } });
            if ( Exercises.findIndex((E) => E === 'teres') > -1 ) LTeres = SortedWorkouts.map((SB) => { return { y: SB.L_torque_teres, Sets: createSetData(SB, 'teres', 'L'), exercise_date: SB.exercise_date } });
            if ( Exercises.findIndex((E) => E === 'house') > -1 ) LHouse = SortedWorkouts.map((SB) => { return { y: SB.L_torque_surfer, Sets: createSetData(SB, 'surfer', 'L'), exercise_date: SB.exercise_date } });
        }

        // For all of the mapped data, if there is a null or '0.0' value for all 5 sets in the same array position, delete that position from the SetX array and label - This will remove X Axis labels where there is no Data.
        let EmptyData = [];
        let max_y_axis = 0;
        RSupra.forEach((S, index) => {
            if ( parseFloat(S.y) > parseFloat(max_y_axis) ) max_y_axis = parseFloat(S.y);

            if ( S.y === null || S.y === '0.000' || S.y === undefined ) {
                EmptyData.push(index);
            }
        });

        // Get the max torque for all of the sets, to use for the y-axis max
        LSupra.forEach((S) => { if ( parseFloat(S.y) > parseFloat(max_y_axis) ) max_y_axis = parseFloat(S.y) });
        RSubscap.forEach((S) => { if ( parseFloat(S.y) > parseFloat(max_y_axis) ) max_y_axis = parseFloat(S.y) });
        LSubscap.forEach((S) => { if ( parseFloat(S.y) > parseFloat(max_y_axis) ) max_y_axis = parseFloat(S.y) });
        RInfra.forEach((S) => { if ( parseFloat(S.y) > parseFloat(max_y_axis) ) max_y_axis = parseFloat(S.y) });
        LInfra.forEach((S) => { if ( parseFloat(S.y) > parseFloat(max_y_axis) ) max_y_axis = parseFloat(S.y) });
        RTeres.forEach((S) => { if ( parseFloat(S.y) > parseFloat(max_y_axis) ) max_y_axis = parseFloat(S.y) });
        LTeres.forEach((S) => { if ( parseFloat(S.y) > parseFloat(max_y_axis) ) max_y_axis = parseFloat(S.y) });
        RHouse.forEach((S) => { if ( parseFloat(S.y) > parseFloat(max_y_axis) ) max_y_axis = parseFloat(S.y) });
        LHouse.forEach((S) => { if ( parseFloat(S.y) > parseFloat(max_y_axis) ) max_y_axis = parseFloat(S.y) });
        console.log({max_y_axis})
        console.log({EmptyData});

        console.log({RSupra});
        console.log({LSupra});
        console.log({RSubscap});
        console.log({LSubscap});
        console.log({RInfra});
        console.log({LInfra});
        console.log({RTeres});
        console.log({LTeres});
        console.log({RHouse});
        console.log({LHouse});

        // let RemovePositions = [];
        // EmptyData.forEach((ED) => {
        //     // If remaining Sets also have empty data, then we will remove those index positions from Labels and Sets arrays
        //     // console.log("ED - RSubscap: ", RSubscap[ED])
        //     if ( 
        //         (LSupra[ED] && LSupra[ED].y === null || LSupra[ED].y === undefined || LSupra[ED].y === '0.000') &&
        //         (RSubscap[ED] && RSubscap[ED].y === null || RSubscap[ED].y === undefined || RSubscap[ED].y === '0.000') &&
        //         (LSubscap[ED] && LSubscap[ED].y === null || LSubscap[ED].y === undefined || LSubscap[ED].y === '0.000') &&
        //         (RInfra[ED] && RInfra[ED].y === null || RInfra[ED].y === undefined || RInfra[ED].y === '0.000') &&
        //         (LInfra[ED] && LInfra[ED].y === null || LInfra[ED].y === undefined || LInfra[ED].y === '0.000') &&
        //         (RTeres[ED] && RTeres[ED].y === null || RTeres[ED].y === undefined || RTeres[ED].y === '0.000') &&
        //         (LTeres[ED] && LTeres[ED].y === null || LTeres[ED].y === undefined || LTeres[ED].y === '0.000') &&
        //         (RHouse[ED] && RHouse[ED].y === null || RHouse[ED].y === undefined || RHouse[ED].y === '0.000') &&
        //         (LHouse[ED] && LHouse[ED].y === null || LHouse[ED].y === undefined || LHouse[ED].y === '0.000')
        //     ) {
        //         RemovePositions.push(ED);
        //     }
        // });
        // console.log({RemovePositions});

        let RSupraFinal = [];
        let LSupraFinal = [];
        let RSubscapFinal = [];
        let LSubscapFinal = [];
        let RInfraFinal = [];
        let LInfraFinal = [];
        let RTeresFinal = [];
        let LTeresFinal = [];
        let RHouseFinal = [];
        let LHouseFinal = [];
        let XAxisLabelsFinal = [];
        // console.log("XAxisLabels: ", XAxisLabels)
        let i;
        // Push final Sets data - unless its index is in the Removed Positions
        for(i = 0; i < XAxisLabels.length; i++) {
            let use_x_axis = false;
            // console.log("RSupra[i]: ", RSupra[i], " | XAxisLabels[i]: ", + XAxisLabels[i], " | TEST: ", RSupra[i] !== null && RSupra[i] !== undefined && RSupra[i] !== '0.000')
            // if ( RemovePositions.findIndex((RP) => RP == i) == -1 ) {
                if ( Arm.findIndex((A) => A === 'R') > -1 ) {

                    if ( Exercises.findIndex((E) => E === 'supra') > -1 && RSupra[i].y !== null && RSupra[i].y !== undefined && RSupra[i].y !== '0.000' ) { RSupraFinal.push({x: XAxisLabels[i], y: RSupra[i].y, Sets: RSupra[i].Sets, exercise_date: RSupra[i].exercise_date }); use_x_axis = true;}
                    if ( Exercises.findIndex((E) => E === 'infra') > -1 && RInfra[i].y !== null && RInfra[i].y !== undefined && RInfra[i].y !== '0.000' ) { RInfraFinal.push({x: XAxisLabels[i], y: RInfra[i].y, Sets: RInfra[i].Sets, exercise_date: RInfra[i].exercise_date }); use_x_axis = true;}
                    if ( Exercises.findIndex((E) => E === 'teres') > -1 && RTeres[i].y !== null && RTeres[i].y !== undefined && RTeres[i].y !== '0.000' ) { RTeresFinal.push({x: XAxisLabels[i], y: RTeres[i].y, Sets: RTeres[i].Sets, exercise_date: RTeres[i].exercise_date }); use_x_axis = true;}
                    if ( Exercises.findIndex((E) => E === 'subscap') > -1 && RSubscap[i].y !== null && RSubscap[i].y !== undefined && RSubscap[i].y !== '0.000' ) { RSubscapFinal.push({x: XAxisLabels[i], y: RSubscap[i].y, Sets: RSubscap[i].Sets, exercise_date: RSubscap[i].exercise_date }); use_x_axis = true;}
                    if ( Exercises.findIndex((E) => E === 'house') > -1 && RHouse[i].y !== null && RHouse[i].y !== undefined && RHouse[i].y !== '0.000' ) { RHouseFinal.push({x: XAxisLabels[i], y: RHouse[i].y, Sets: RHouse[i].Sets, exercise_date: RHouse[i].exercise_date }); use_x_axis = true;}
                
                }

                if ( Arm.findIndex((A) => A === 'L') > -1 ) {

                    if ( Exercises.findIndex((E) => E === 'supra') > -1 && LSupra[i].y !== null && LSupra[i].y !== undefined && LSupra[i].y !== '0.000' ) { LSupraFinal.push({x: XAxisLabels[i], y: LSupra[i].y, Sets: LSupra[i].Sets, exercise_date: LSupra[i].exercise_date }); use_x_axis = true;}
                    if ( Exercises.findIndex((E) => E === 'infra') > -1 && LInfra[i].y !== null && LInfra[i].y !== undefined && LInfra[i].y !== '0.000' ) { LInfraFinal.push({x: XAxisLabels[i], y: LInfra[i].y, Sets: LInfra[i].Sets, exercise_date: LInfra[i].exercise_date }); use_x_axis = true;}
                    if ( Exercises.findIndex((E) => E === 'teres') > -1 && LTeres[i].y !== null && LTeres[i].y !== undefined && LTeres[i].y !== '0.000' ) { LTeresFinal.push({x: XAxisLabels[i], y: LTeres[i].y, Sets: LTeres[i].Sets, exercise_date: LTeres[i].exercise_date }); use_x_axis = true;}
                    if ( Exercises.findIndex((E) => E === 'subscap') > -1 && LSubscap[i].y !== null && LSubscap[i].y !== undefined && LSubscap[i].y !== '0.000' ) { LSubscapFinal.push({x: XAxisLabels[i], y: LSubscap[i].y, Sets: LSubscap[i].Sets, exercise_date: LSubscap[i].exercise_date }); use_x_axis = true;}
                    if ( Exercises.findIndex((E) => E === 'house') > -1 && LHouse[i].y !== null && LHouse[i].y !== undefined && LHouse[i].y !== '0.000' ) { LHouseFinal.push({x: XAxisLabels[i], y: LHouse[i].y, Sets: LHouse[i].Sets, exercise_date: LHouse[i].exercise_date }); use_x_axis = true;}
                
                }
                // console.log({use_x_axis})
                // Only add this X Axis label if we pushed a value above
                if ( use_x_axis === true ) {XAxisLabelsFinal.push(XAxisLabels[i]);}
            // } 
        }

        // console.log({XAxisLabelsFinal});
        // console.log({RSupraFinal});
        // console.log({LSupraFinal});
        // console.log({RSubscapFinal});
        // console.log({LSubscapFinal});
        // console.log({RInfraFinal});
        // console.log({LInfraFinal});
        // console.log({RTeresFinal});
        // console.log({LTeresFinal});
        // console.log({RHouseFinal});
        // console.log({LHouseFinal});
        let BaseDataSet = GraphType === 'line' ?  { borderColor: 'black', borderWidth: 2 } : { borderColor: 'black', borderWidth: 2 };
        let BaseDataSetND = GraphType === 'line' ?  { borderColor: 'black', borderWidth: 2, borderDash: [6, 2] } : { borderColor: 'black', borderWidth: 2 };

        let bg1 = 'Blue';
        let bg2 = 'Orange';
        let bg5 = 'Purple';
        let bg3 = 'Red';
        let bg4 = 'Green';

        // Blues
        // let bg1 = '#ADC8E6';
        // let bg2 = '#87CEFA';
        // let bg5 = '#B3CEE5';
        // let bg3 = '#C8DCE6';
        // let bg4 = '#96B4C8';
        // Greys
        // let bg1 = '#5A5A5A';
        // let bg2 = '#818589';
        // let bg3 = '#808080';
        // let bg4 = '#899499';
        // let bg5 = '#D3D3D3';

        function createDiagonalPattern(color = 'black') {
            // create a 10x10 px canvas for the pattern's base shape
            let shape = document.createElement('canvas')
            shape.width = 10
            shape.height = 10
            // get the context for drawing
            let c = shape.getContext('2d')
            // draw 1st line of the shape 
            c.strokeStyle = color
            c.beginPath()
            c.moveTo(2, 0)
            c.lineTo(10, 8)
            c.stroke()
            // draw 2nd line of the shape 
            c.beginPath()
            c.moveTo(0, 8)
            c.lineTo(2, 10)
            c.stroke()
            // create the pattern from the shape
            return c.createPattern(shape, 'repeat')
          }

        // Lastly, check if any of the Sets have only null or '0.000', we can condense the datasets if so.
        let TempDatasets = [];
        if ( RSupraFinal.findIndex((S) => S.y !== null && S.y !== '0.000' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSet, data: RSupraFinal, label: 'Supra - Right', borderColor: bg1, backgroundColor: bg1, borderWidth: 1, datalabels: { align: 'start', anchor: 'end'} });
        if ( LSupraFinal.findIndex((S) => S.y !== null && S.y !== '0.000' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSetND, data: LSupraFinal, label: 'Supra - Left', borderColor: bg1, backgroundColor: createDiagonalPattern(bg1), borderWidth: 1, datalabels: { align: 'end', anchor: 'end'} });
        if ( RInfraFinal.findIndex((S) => S.y !== null && S.y !== '0.000' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSet, data: RInfraFinal, label: 'Infra - Right', borderColor: bg3, backgroundColor: bg3, borderWidth: 1 });
        if ( LInfraFinal.findIndex((S) => S.y !== null && S.y !== '0.000' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSetND, data: LInfraFinal, label: 'Infra - Left', borderColor: bg3, backgroundColor: createDiagonalPattern(bg3), borderWidth: 1 });
        if ( RTeresFinal.findIndex((S) => S.y !== null && S.y !== '0.000' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSet, data: RTeresFinal, label: 'Teres Minor - Right', borderColor: bg4, backgroundColor: bg4, borderWidth: 1, datalabels: { align: 'start', anchor: 'start'} });
        if ( LTeresFinal.findIndex((S) => S.y !== null && S.y !== '0.000' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSetND, data: LTeresFinal, label: 'Teres Minor - Left', borderColor: bg4, backgroundColor: createDiagonalPattern(bg4), borderWidth: 1, datalabels: { align: 'start', anchor: 'start'} });
        if ( RSubscapFinal.findIndex((S) => S.y !== null && S.y !== '0.000' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSet, data: RSubscapFinal, label: 'Subscap - Right', borderColor: bg2, backgroundColor: bg2, borderWidth: 1, datalabels: { align: 'end', anchor: 'end'} });
        if ( LSubscapFinal.findIndex((S) => S.y !== null && S.y !== '0.000' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSetND, data: LSubscapFinal, label: 'Subscap - Left', borderColor: bg2, backgroundColor: createDiagonalPattern(bg2), borderWidth: 1, datalabels: { align: 'end', anchor: 'end'} });
        if ( RHouseFinal.findIndex((S) => S.y !== null && S.y !== '0.000' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSet, data: RHouseFinal, label: 'House Combo - Right', borderColor: bg5, backgroundColor: bg5, borderWidth: 1, datalabels: { align: 'start', anchor: 'start'} });
        if ( LHouseFinal.findIndex((S) => S.y !== null && S.y !== '0.000' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSetND, data: LHouseFinal, label: 'House Combo - Left', borderColor: bg5, backgroundColor: createDiagonalPattern(bg5), borderWidth: 1, datalabels: { align: 'start', anchor: 'start'} });
        console.log({TempDatasets});

        console.log("dayjs(StartDate).isValid(): ", dayjs(StartDate).isValid())
        console.log("dayjs(EndDate).isValid(): ", dayjs(EndDate).isValid())
        // If Start / End Dates are valid, then filter the Datasets for this:
        if ( dayjs(StartDate).isValid() || dayjs(EndDate).isValid() ) {
            TempDatasets = TempDatasets.map((TDS) => {
                let TempData = TDS.data.filter((DS) => {
                    let valid = true;
                    if ( dayjs(StartDate).isValid() && dayjs(StartDate).isAfter(DS.exercise_date) ) {
                        console.log("Failed STart date, DS.exercise_date: ", DS.exercise_date)
                        valid = false;
                    }
                    if ( dayjs(EndDate).isValid() && dayjs(EndDate).isBefore(DS.exercise_date) ) {
                        console.log("Failed end date, DS.exercise_date: ", DS.exercise_date)

                        valid = false;
                    }
                    console.log({valid})
                    if ( valid === true ) {
                        return DS;
                    } else {
                        return null;
                    }
                });
                console.log({TempData})
                return {...TDS, data: TempData };
            });

            XAxisLabelsFinal = XAxisLabelsFinal.filter((label) => {
                let valid = true;
                if ( dayjs(StartDate).isValid() && dayjs(StartDate).isAfter(label) ) {
                    console.log("Failed STart date, label: ", label)
                    valid = false;
                }
                if ( dayjs(EndDate).isValid() && dayjs(EndDate).isBefore(label) ) {
                    console.log("Failed end date, label: ", label)

                    valid = false;
                }
                console.log({valid})
                if ( valid === true ) {
                    return label;
                } else {
                    return null;
                }
        });
        }
        setGraphData({
            ...GraphData,
            labels: XAxisLabelsFinal,
            datasets: TempDatasets
        });

        // Create graph title
        let temp_arm = 'Right & Left';
        if ( Arm.length === 1 ) {
            if ( Arm.findIndex((A) => A === 'L') > -1 ) temp_arm = 'Left';
            else if ( Arm.findIndex((A) => A === 'R') > -1  ) temp_arm = 'Right';
        }
        let temp_ex = Exercises.length === 5 ? ['All Exercises'] : [];
        if ( Exercises.length !== 5) {
            if ( Exercises.findIndex((E) => E === 'supra') > -1 ) temp_ex.push('Supra');
            if ( Exercises.findIndex((E) => E === 'infra') > -1 ) temp_ex.push('Infra');
            if ( Exercises.findIndex((E) => E === 'teres') > -1 ) temp_ex.push('Teres Minor');
            if ( Exercises.findIndex((E) => E === 'subscap') > -1 ) temp_ex.push('Subscap');
            if ( Exercises.findIndex((E) => E === 'house') > -1 ) temp_ex.push('House Combo');
        } 
        let graph_title = `${temp_ex.join(', ')} - ${temp_arm}`;
        if ( Arm.length === 0 ) graph_title = 'PLEASE SELECT RIGHT OR LEFT SIDE TO GENERATE GRAPH';
        else if ( Exercises.length === 0 ) graph_title = 'PLEASE SELECT EXERCISE(S) TO GENERATE GRAPH';

        // Calculate y max
        let step_y_axis = max_y_axis < 200 ? 10 : 20;
        let max_y_axis_label = multiply(add(Math.floor(divide(max_y_axis,step_y_axis)),1),step_y_axis);

        setGraphOptions({
            ...GraphOptions,
            plugins: {
                ...GraphOptions.plugins,
                title: {
                    ...GraphOptions.plugins.title,
                    text: graph_title 
                },
                tooltip: {
                    enabled: true,
                    // mode: "index",
                    intersect: false,
                    backgroundColor: 'grey',
                    borderColor: function(context) {
                        // console.log("BORDER COLOR CONTEXT: ", context)
                        if ( context.tooltipItems.length > 0 ) {
                            return context.tooltipItems[0].dataset.borderColor
                        } else {
                            return 'black';
                        }
                    },
                    callbacks: { //Added callbacks for label
                        // title: () => {
                        //     return "title here";
                        // },
                        // labelColor: function(context) {
                        //     console.log("LABEL COLOR CONTEXT: ", context)
                        //     return {
                        //         borderColor: 'red'
                        //     }
                        // },
                        title: (context) => {
                            console.log({context})
                            // context is an array of tooltip items
                            return `${context[0].dataset.label}     ${dayjs(context[0].raw.exercise_date).format('MM-DD-YY')}`; // Displays the dataset label as the title
                        },
                        label: (context) => {
                            // context is the tooltip item
                            // console.log("CONTEXT LABEL: ", context)
                            let Lines = [`  Work Done: ${context.formattedValue} ft-lbs`];
                            Lines.push('');
                            context.raw.Sets.forEach((Set, index)=> Lines.push( `  Set ${index+1}:    ${Set.reps} Rep${(Set.reps > 1 && 's') || ''}  -  ${Set.weight} lbs` ) );

                            return Lines;
                        },
                        // footer: (context) => {
                        //     // context is an array of tooltip items
                        //     let sum = 0;
                        //     context.forEach((item) => {
                        //         sum += item.parsed.y;
                        //     });
                        //     return `Sum: ${sum}`; // Displays the sum of values in the tooltip
                        // },                    
                    }
                },
    
            },
            scales: {
                y: {
                    beginAtZero: true,
                    max: max_y_axis_label,
                    min: 0,
                    ticks: {
                        stepSize: step_y_axis
                    },
                    title: {
                        display: true,
                        text: 'Work Done (ft-lbs)'
                    }
                },
                x: {                    
                    grid: {
                        color: 'lightGrey', // Set the color of the grid lines, including the axis line
                        lineWidth: 3 // Set the width of the grid lines, including the axis line
                    }
                }
            }
        });

        setGraphGenerated(true);
        setTimeout(() => targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' }), GraphGenerated ? 0 : 300);
    }

    // Click handler for selecting exercises to graph. If the exercise is already in the array, remove it, otherwise add it.
    function handleSetExercises(exercise) {

        let index = Exercises.findIndex((E) => E === exercise );
        let TempExercises = [...Exercises];

        if ( exercise === 'all' ) {
            TempExercises = ['supra','infra','teres','subscap','house'];
        } else if ( exercise === 'clear' ) {
            TempExercises = [];
        } else if ( index > -1 ) {
            TempExercises.splice(index, 1);
        } else {
            TempExercises.push(exercise);
        }
        setExercises(TempExercises);
        targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    };

    // Click handler for selecting arm sides to graph. If the side is already in the array, remove it, otherwise add it.
    function handleSetArm(arm) {
        let index = Arm.findIndex((A) => A === arm );
        let TempArm = [...Arm];
        if ( index > -1 ) {
            TempArm.splice(index, 1);
        } else {
            TempArm.push(arm);
        }
        setArm(TempArm);
        targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' })
    };

    console.log({Arm})
    console.log({Exercises})
    console.log({GraphData})
    console.log({GraphOptions})
    return (
        <div className="card mb-4">
            {
                GraphGenerated &&
                <Printing class={'btn btn-sm border-primary text-primary fw-bold border-3'} button={"Print Graph"} />
            }
            {
                !GraphGenerated && 
                <div className="card-body">
                    <div className="row justify-content-center">
                        <div className="col-auto">
                            <div className="alert alert-info mb-0">Select an Exercise and Arm below, then click to Generate Graph.</div>
                        </div>
                    </div>
                </div>
            }
            <div className="card-footer border border-secondary" ref={targetRef}>
                {/* Button filters for Exercise, Arm */}
                <div className="row clearfix my-1 justify-content-center">

                    <div className="col-auto">
                        {/* <label className="text-muted" htmlFor="date_start">Start Date</label> */}
                        <input type="date" className="form-control" id="date_start" value={StartDate || ""} onChange={(event) => setStartDate(event.target.value)} />
                    </div>
                    <div className="col-auto mx-0 pt-2 px-0">
                        To
                    </div>
                    <div className="col-auto">
                        {/* <label className="text-muted" htmlFor="date_start">Start Date</label> */}
                        <input type="date" className="form-control" id="date_end" value={EndDate || ""} onChange={(event) => setEndDate(event.target.value)} />
                    </div>

                    <div className="col-auto">
                        <div className="btn-group" role="group">
                            <button className={`btn btn-outline-secondary text-dark}`} onClick={() => handleSetExercises('all')}>
                                All
                            </button>
                            <button className={`btn btn-outline-secondary ${(Exercises.findIndex((E) => E === 'supra') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('supra')}>
                                Supra
                            </button>
                            <button className={`btn btn-outline-secondary ${(Exercises.findIndex((E) => E === 'infra') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('infra')}>
                                Infra
                            </button>
                            <button className={`btn btn-outline-secondary ${(Exercises.findIndex((E) => E === 'teres') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('teres')}>
                                Teres Minor
                            </button>
                            <button className={`btn btn-outline-secondary ${(Exercises.findIndex((E) => E === 'subscap') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('subscap')}>
                                Subscap
                            </button>
                            <button className={`btn btn-outline-secondary ${(Exercises.findIndex((E) => E === 'house') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('house')}>
                                House Combo
                            </button>
                            <button className={`btn btn-outline-secondary text-dark}`} onClick={() => handleSetExercises('clear')}>
                                Clear
                            </button>
                        </div>                            
                    </div>

                    <div className="col-auto">
                        <div className="btn-group" role="group">
                            <button className={`btn btn-outline-secondary ${(Arm.findIndex((A) => A === 'L') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetArm('L')}>
                                Left
                            </button>
                            <button className={`btn btn-outline-secondary ${(Arm.findIndex((A) => A === 'R') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetArm('R')}>
                                Right
                            </button>
                        </div>                            
                    </div>

                    <div className="col-auto">
                        <div className="btn-group" role="group">
                            <button className={`btn btn-outline-secondary ${(GraphType === 'bar' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => setGraphType('bar')}>
                                Bar
                            </button>
                            <button className={`btn btn-outline-secondary ${(GraphType === 'line' && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => setGraphType('line')}>
                                Line
                            </button>
                        </div>                            
                    </div>

                    
                    {/* <div className="col-auto">
                        <button className="btn btn-sm border-primary text-primary fw-bold border-3" onClick={() => handleGenerateGraph()} disabled={ Exercise === '' || Arm === '' } >
                            <FontAwesomeIcon icon="fa-signal" className="me-2" />Generate Graph
                        </button>
                    </div> */}

                </div>
            </div>
        </div>
    )
}


// This is the handleGraph for the original version of Workout Graph - where we would only chart a single exercise and arm side combo.
    // Handle generating graph data and options for exercise and arm
    // function handleGenerateGraph() {

    //     // We will have 5 potential datasets - L / R each for 5 sets
    //     let Set1 = SortedWorkouts.map((SW) => {return {weight: SW[`${Arm}1_weight_${Exercises}`], reps: SW[`${Arm}1_rep_${Exercises}`]}});
    //     let Set2 = SortedWorkouts.map((SW) => {return {weight: SW[`${Arm}2_weight_${Exercises}`], reps: SW[`${Arm}2_rep_${Exercises}`]}});
    //     let Set3 = SortedWorkouts.map((SW) => {return {weight: SW[`${Arm}3_weight_${Exercises}`], reps: SW[`${Arm}3_rep_${Exercises}`]}});
    //     let Set4 = SortedWorkouts.map((SW) => {return {weight: SW[`${Arm}4_weight_${Exercises}`], reps: SW[`${Arm}4_rep_${Exercises}`]}});
    //     let Set5 = SortedWorkouts.map((SW) => {return {weight: SW[`${Arm}5_weight_${Exercises}`], reps: SW[`${Arm}5_rep_${Exercises}`]}});
    //     // let Set5 = SortedWorkouts.map((SW) => SW[`${Arm}5_weight_${Exercises}`]);        
    //     console.log({Set1})
    //     // For all of the mapped data, if there is a null or '0.0' value for all 5 sets in the same array position, delete that position from the SetX array and label - This will remove X Axis labels where there is no Data.
    //     let EmptyData = [];
    //     let max_y_axis = 0;
    //     Set1.forEach((S, index) => {
    //         if ( S.weight > max_y_axis ) max_y_axis = S.weight;

    //         if ( S.weight === null || S.weight === '0.0' ) {
    //             EmptyData.push(index);
    //         }
    //     });

    //     // Get the max weight for all of the sets, to use for the y-axis max
    //     Set2.forEach((S) => { if ( S.weight > max_y_axis ) max_y_axis = S.weight  });
    //     Set3.forEach((S) => { if ( S.weight > max_y_axis ) max_y_axis = S.weight  });
    //     Set4.forEach((S) => { if ( S.weight > max_y_axis ) max_y_axis = S.weight  });
    //     Set5.forEach((S) => { if ( S.weight > max_y_axis ) max_y_axis = S.weight  });
    //     console.log({max_y_axis})
    //     console.log({EmptyData});
    //     let RemovePositions = [];
    //     EmptyData.forEach((ED) => {
    //         // If Sets 2-5 also have empty data, then we will remove those index positions from Labels and Sets arrays
    //         if ( (Set2[ED].weight === null || Set2[ED].weight === '0.0') && (Set3[ED].weight === null || Set3[ED].weight === '0.0') && (Set4[ED].weight === null || Set4[ED].weight === '0.0') && (Set5[ED].weight === null || Set5[ED].weight === '0.0') ) {
    //             RemovePositions.push(ED);
    //         }
    //     });
    //     console.log({RemovePositions});

    //     let Set1Final = [];
    //     let Set2Final = [];
    //     let Set3Final = [];
    //     let Set4Final = [];
    //     let Set5Final = [];
    //     let XAxisLabelsFinal = [];
    //     let i;
    //     // Push final Sets data - unless its index is in the Removed Positions
    //     for(i = 0; i < XAxisLabels.length; i++) {
    //         let use_x_axis = false;
    //         if ( RemovePositions.findIndex((RP) => RP == i) == -1 ) {
    //             if ( Set1[i].weight !== '0.0' ) Set1Final.push({reps: Set1[i].reps, x: XAxisLabels[i], y: Set1[i].weight}); use_x_axis = true;
    //             if ( Set2[i].weight !== '0.0' ) Set2Final.push({reps: Set2[i].reps, x: XAxisLabels[i], y: Set2[i].weight}); use_x_axis = true;
    //             if ( Set3[i].weight !== '0.0' ) Set3Final.push({reps: Set3[i].reps, x: XAxisLabels[i], y: Set3[i].weight}); use_x_axis = true;
    //             if ( Set4[i].weight !== '0.0' ) Set4Final.push({reps: Set4[i].reps, x: XAxisLabels[i], y: Set4[i].weight}); use_x_axis = true;
    //             if ( Set5[i].weight !== '0.0' ) Set5Final.push({reps: Set5[i].reps, x: XAxisLabels[i], y: Set5[i].weight}); use_x_axis = true;

    //             Set1Final.push(Set1[i]);
    //             Set2Final.push(Set2[i]);
    //             Set3Final.push(Set3[i]);
    //             Set4Final.push(Set4[i]);
    //             Set5Final.push(Set5[i]);
    //             // Set1Final.push(Set1[i]);
    //             // Set2Final.push(Set2[i]);
    //             // Set3Final.push(Set3[i]);
    //             // Set4Final.push(Set4[i]);
    //             // Set5Final.push(Set5[i]);

    //             // Only add this X Axis label if we pushed a value above
    //             if ( use_x_axis === true ) XAxisLabelsFinal.push(XAxisLabels[i]);
    //         } 
    //     }

    //     console.log({Set1Final});
    //     console.log({Set2Final});
    //     console.log({Set3Final});
    //     console.log({Set4Final});
    //     console.log({Set5Final});
    //     let BaseDataSet = { borderColor: 'black', borderWidth: 2 };

    //     // Blues
    //     let bg1 = '#ADC8E6';
    //     let bg2 = '#87CEFA';
    //     let bg5 = '#B3CEE5';
    //     let bg3 = '#C8DCE6';
    //     let bg4 = '#96B4C8';
    //     // Greys
    //     // let bg1 = '#5A5A5A';
    //     // let bg2 = '#818589';
    //     // let bg3 = '#808080';
    //     // let bg4 = '#899499';
    //     // let bg5 = '#D3D3D3';

    //     // Lastly, check if any of the Sets have only null or '0.0', we can condense the datasets if so.
    //     let TempDatasets = [];
    //     if ( Set1Final.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSet, data: Set1Final, label: 'Set 1', backgroundColor: bg1 });
    //     if ( Set2Final.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSet, data: Set2Final, label: 'Set 2', backgroundColor: bg2 });
    //     if ( Set3Final.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSet, data: Set3Final, label: 'Set 3', backgroundColor: bg3 });
    //     if ( Set4Final.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSet, data: Set4Final, label: 'Set 4', backgroundColor: bg4 });
    //     if ( Set5Final.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1 ) TempDatasets.push({...BaseDataSet, data: Set5Final, label: 'Set 5', backgroundColor: bg5 });
    //     console.log({TempDatasets});

    //     setGraphData({
    //         ...GraphData,
    //         labels: XAxisLabelsFinal,
    //         datasets: TempDatasets
    //     });

    //     // Create graph title
    //     let temp_arm = Arm === 'L' ? 'Left' : 'Right';
    //     let temp_ex = Exercises.length === 5 ? ['All Exercises'] : [];
    //     if ( Exercises.length !== 5) {
    //         if ( Exercises.findIndex((E) => E === 'supra') > -1 ) temp_ex.push('Supra');
    //         if ( Exercises.findIndex((E) => E === 'subscap') > -1 ) temp_ex.push('Subscap');
    //         if ( Exercises.findIndex((E) => E === 'infra') > -1 ) temp_ex.push('Infra');
    //         if ( Exercises.findIndex((E) => E === 'teres') > -1 ) temp_ex.push('Teres Minor');
    //         if ( Exercises.findIndex((E) => E === 'house') > -1 ) temp_ex.push('House Combo');
    //     } 
    //     console.log({temp_ex})
    //     let graph_title = `${temp_ex.join(', ')} - ${temp_arm}`;
    //     if ( Arm.length === 0 ) graph_title = 'PLEASE SELECT DOMINANT OR NON-DOMINANT SIDE TO GENERATE GRAPH';
    //     else if ( Exercises.length === 0 ) graph_title = 'PLEASE SELECT EXERCISE(S) TO GENERATE GRAPH';

    //     setGraphOptions({
    //         ...GraphOptions,
    //         plugins: {
    //             ...GraphOptions.plugins,
    //             title: {
    //                 ...GraphOptions.plugins.title,
    //                 text: graph_title 
    //             }
    //         },
    //         tooltips: {
    //             mode: "index",
    //             intersect: false,
    //             callbacks: { //Added callbacks for label
    //                 title: () => {
    //                     return "";
    //                 },
    //                 label: (tooltipItems, data) => {
    //                     console.log({tooltipItems});
    //                     console.log({data})
    //                     // return "(" + tooltipItems.yLabel + ")";
    //                     return "(" + tooltipItems.xLabel + "," + tooltipItems.yLabel + ")";
    //                     // return "Banana";
    //                 }
    //                 // title: (context) => {
    //                 //     // context is an array of tooltip items
    //                 //     return context[0].dataset.label; // Displays the dataset label as the title
    //                 //   },
    //                 //   label: (context) => {
    //                 //     // context is the tooltip item
    //                 //     return `Value: ${context.formattedValue}`; // Displays the formatted value
    //                 //   },
    //                 //   footer: (context) => {
    //                 //     // context is an array of tooltip items
    //                 //     let sum = 0;
    //                 //     context.forEach((item) => {
    //                 //       sum += item.parsed.y;
    //                 //     });
    //                 //     return `Sum: ${sum}`; // Displays the sum of values in the tooltip
    //                 //   },                    
    //             }
    //         },
    //         scales: {
    //             y: {
    //                 beginAtZero: true,
    //                 max: add(max_y_axis,1),
    //                 min: 0,
    //                 ticks: {
    //                     stepSize: max_y_axis < 10 ? 1 : 2
    //                 },
    //                 title: {
    //                     display: true,
    //                     text: 'Weight (Lbs)'
    //                 }
    //             },
    //             // x : [
    //             //     {
                        
    //             //     }
    //             // ]
    //         }
    //     });

    //     // scales: {
    //     //     y: {
    //     //     },
    //     // }

    //     setGraphGenerated(true);
    //     setTimeout(() => targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' }), GraphGenerated ? 0 : 300);
    // }
